import React from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'connected-react-router';
import { showNotification, updateActiveSection, updateContentHeight } from '../redux/actions';
import { activateSection } from '../../MainNavigation/redux/actions';
import FrameCollectionComponent from '../components/FrameCollectionComponent';
import NotificationDisplayUtils from "../utils/NotificationDisplayUtils";
import MenuSection from "../../../types/MenuSection";

const mapStateToProps = ( state ) =>
{
    return {
        focusedSectionSpec: state.frameCollection.focusedSectionSpec,
        iframeSectionSpec: state.frameCollection.iframeSectionSpec,
        focusedSectionId: state.frameCollection.focusedSectionSpec && state.frameCollection.focusedSectionSpec.sectionId,
        isLeftSideMenuPinned: state.mainNavigation.leftMenuState.isPinnedOpen,
        isDebugInfoOpen: state.mainNavigation.debugInfoState.isOpen,

        contentHeight: state.frameCollection.contentHeight,
        lastLoadTimeStamp: state.mainNavigation.leftMenuState.lastLoadTimeStamp,
        leftSideMenu: state.mainNavigation.menuSpec.leftSideMenu,
        userRole: state.mainNavigation.menuSpec.userRole,
        location: state.router.location,
    };
};

const mapDispatchToProps = dispatch => ( {
    activateSection: ( sectionSpec: MenuSection, pushUrl: boolean, updateTimeStamp: boolean ) =>
    {
        dispatch( activateSection( sectionSpec, pushUrl, updateTimeStamp ) );
    },

    showNotification: ( message: string, type: NotificationDisplayUtils ) =>
    {
        dispatch( showNotification( message, type ) );
    },

    updateActiveSection: ( newUrl: string, pushUrl?: boolean, updateTimeStamp?: boolean ) =>
    {
        dispatch( updateActiveSection( newUrl, pushUrl, updateTimeStamp ) );
    },

    updateBrowserLocation: ( newUrl: string ) =>
    {
        dispatch( push( newUrl ) );
    },

    replaceBrowserLocation: ( newUrl: string ) =>
    {
        dispatch( replace( newUrl ) );
    },

    updateContentHeight: ( newHeight: number ) =>
    {
        dispatch( updateContentHeight( newHeight ) );
    }
} );

const FrameCollectionContainer: any = props => <FrameCollectionComponent {...props}/>;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( FrameCollectionContainer );
